import { useState } from "react";
import { useTranslation } from "react-i18next";

const Faq = () => {
  const { t, i18n } = useTranslation();

  const faqs = t("faq.questions", { returnObjects: true });

  // Tabs traducidos dinámicamente
  const categories = [
    {
      key: "common",
      label: i18n.language === "es" ? "Problemas" : "Common Issues",
    },
    {
      key: "spare",
      label: i18n.language === "es" ? "Repuestos" : "Spare Parts",
    },
    { key: "sla", label: "SLA" },
    { key: "school", label: "School" },
  ];

  // Filtrado automático por palabras clave en ambos idiomas
  const categorizedFaqs = {
    common: faqs.filter((f) => f.category === "common"),
    spare: faqs.filter((f) => f.category === "spare"),
    sla: faqs.filter((f) => f.category === "sla"),
    school: faqs.filter((f) => f.category === "school"),
  };

  const [activeCategory, setActiveCategory] = useState("common");
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-8 font-sans">
      <h2 className="text-4xl font-bold mb-8 text-orange-600 text-center">
        {t("faq.title")}
      </h2>

      {/* ---- Category Tabs ---- */}
      <div className="flex justify-center flex-wrap gap-3 mb-6">
        {categories.map((cat) => (
          <button
            key={cat.key}
            onClick={() => {
              setActiveCategory(cat.key);
              setOpenIndex(null);
            }}
            className={`px-4 py-2 rounded-full font-semibold transition ${
              activeCategory === cat.key
                ? "bg-darkBlue text-white"
                : "bg-gray-200 text-darkBlue hover:bg-gray-300"
            }`}
          >
            {cat.label}
          </button>
        ))}
      </div>

      {/* ---- FAQ Content ---- */}
      {categorizedFaqs[activeCategory]?.length > 0 ? (
        categorizedFaqs[activeCategory].map((faq, index) => (
          <div
            key={index}
            className="mb-4 border rounded-lg overflow-hidden shadow-sm"
          >
            <button
              onClick={() => toggleFaq(index)}
              className="w-full text-left px-4 py-3 bg-darkBlue hover:bg-veryDarkBlue font-semibold text-white flex justify-between items-center"
            >
              {faq.q}
              <span className="text-lg">{openIndex === index ? "−" : "+"}</span>
            </button>
            {openIndex === index && (
              <div className="px-4 py-3 bg-white text-gray-700 whitespace-pre-line">
                {faq.a}
              </div>
            )}
          </div>
        ))
      ) : (
        <p className="text-center text-gray-500">
          {i18n.language === "es"
            ? "No hay preguntas disponibles para esta categoría."
            : "No questions available for this category."}
        </p>
      )}
    </div>
  );
};

export default Faq;
